import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { fetchCurrentMember, logout as apiLogout } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchCurrentMember();
      setMember(data);
    } catch {
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    await apiLogout();
    setMember(null);
  }, []);

  // Memoise the value so consumers don't re-render on unrelated parent renders — the object only
  // changes when member/loading actually change (refresh/logout are stable useCallbacks).
  const value = useMemo(
    () => ({ member, loading, isAuthenticated: !!member, refresh, logout }),
    [member, loading, refresh, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
}
